import { TileRoleRoute } from '@/types'
import { faMoneyBill } from '@fortawesome/free-solid-svg-icons'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'

export const FatturazioneInterventoRoute: TileRoleRoute = {
  path: 'fatturazioneintervento',
  text: 'Fatturazione Intervento',
  faIcon: faMoneyBill,
  element: (
    <ManagementGridFactory
      entity="fatturazione_intervento"
      referencesCollection={'interventi'}
      referencesTitle="Fatturazione Intervento"
      displayField="id"
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Fatturazione Intervento',
      icon: faMoneyBill,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
